module.exports = __webpack_public_path__ + "static/media/14-brannbil.0ad81d50.mp3";